import { AssessmentAnswer } from "./assessment"
import { ClassStatus, PracticeQuizState } from "./class"
import { QuizCurrentQuestion, QuizState } from "./quiz"
import { ClassContent, Session, SessionPoint } from "./session"
import { UserRole } from "./user"

export enum SignalRMethodName {
    connect = 'SendPing',
    leaveRoom = 'LeaveRoom',
    chooseGroup = 'ChooseGroup',
    changeGroup = 'ChangeGroup',
    askJoinRoom = 'AskJoinRoom',
    approveJoin = 'ApproveJoin',
    startClassRoom = 'StartClassRoom',
    endClassRoom = 'Finish',
    requestRaiseHand = 'RequestRaiseHand',
    removeRequestRaiseHand = 'TeacherRemoveRaiseHandle',
    raiseHand = 'RaiseHand',
    removeRaiseHand = 'RemoveRaiseHandle',
    lockScreen = 'LockScreen',
    rewardPoint = 'RewardPoint',
    rewardPointGroup = 'RewardPointGroup',
    controlScreen = 'ControlScreen',
    setPracticeState = 'SetPracticeState',
    updateQuizUrl = 'UpdateQuizUrl',
    updateLectureQuestion = 'UpdateLectureQuestion',
    selectStudentAnswer = 'SelectStudentAnswer',
    received = 'ReceiveMessage',
    startQuiz = 'StartQuiz',
    answerQuestion = 'AnswerQuestion',
    finishedQuiz = 'FinishedQuiz',
    changeQuizQuestion = 'ChangeQuizQuestion',
    finishedCurrentQuestion = 'FinishedCurrentQuestion',
    reviewCurrentQuestion = 'ReviewCurrentQuestion',
    settingQuiz = 'SettingQuiz',
    updateQuizState = 'UpdateStatusQuiz',
    settingLecture = 'SettingLecture',
    submitLecture = 'SubmitLecture'
}

export enum SignalRActionName {
    joined = 'PONG',
    chooseGroup = 'ON_USER_CHOOSE_GROUP',
    changeGroup = 'ON_USER_CHANGE_GROUP',
    askJoinRoom = 'ON_USER_ASK_JOIN_ROOM',
    approveJoin = 'ON_TEACHER_ACCEPTED_JOIN_ROOM',
    roomReady = 'ON_ROOM_READY',
    roomFinished = 'ON_TEACHER_FINISHED_ICLASS',
    userLeftRoom = 'ON_USER_LEFT_ROOM',
    userDisconnected = 'ON_USER_DISCONNECTED',
    requestRaiseHand = 'ON_TEACHER_REQUEST_RAISE_HAND',
    raiseHandUpdate = 'ON_USER_RAISE_HAND_UPDATE',
    lockScreen = 'ON_TEACHER_LOCK_UNLOCK_SCREEN',
    rewardPoint = 'ON_REWARD_POINT',
    rewardPointGroup = 'ON_REWARD_POINT_GROUP',
    controlScreen = 'ON_TEACHER_CONTROL_SCREEN',
    setPracticeState = 'ON_TEACHER_SET_PRACTICE_STATE',
    updateQuizUrl = 'ON_TEACHER_UPDATE_QUIZ_URL',
    updateLectureQuestion = 'ON_TEACHER_UPDATE_LECTURE_QUESTION',
    selectStudentAnswer = 'ON_HANDLE_RAISED_SELECTED',
    error = 'ON_ERROR',
    quizReady = 'ON_QUIZ_READY',
    userAnswerQuestion = 'ON_USER_ANSWER_QUESTION',
    quizSetting = 'ON_TEACHER_SETTING_QUIZ',
    quizFinished = 'ON_TEACHER_FINISHED_QUIZ',
    changeQuestion = 'ON_TEACHER_CHANGE_QUESTION',
    finishedCurrentQuestion = 'ON_TEACHER_FINISHED_CURRENT_QUESTION',
    reviewCurrentQuestion = 'ON_TEACHER_REVIEW_CURRENT_QUESTION',
    updateQuizState = 'ON_UPDATE_STATUS_QUIZ',
    lectureSetting = 'ON_TEACHER_SETTING_LECTURE',
    lectureSubmit = 'ON_USER_SUBMIT_LECTURE'
}

export interface SignalRPayload {
    replyId: number | null
    action: SignalRActionName
    message: string
    userId: string
    data: any
}

export interface SignalRActionPayload extends SignalRPayload {
    data: {
        user?: SignalRUser
        room: SignalRRoom
        content?: ClassContent
    }
}

export interface SignalRRoom {
    isReady: boolean
    lockScreen: boolean
    name: string
    state: ClassStatus
    teacherConnectionId: string | null
    users: SignalRUserMap
    listRaiseHand: SignalRUser[]
    groups: SignalRGroups
    currentScreen: Session | null
    practiceStart: PracticeQuizState | null
    currentQuestion: string | null
    listStudentAnswer: SignalRUser[]
    allowRaiseHand: boolean
    listRequestJoinRoom: SignalRUser[]
    expiredTime: number
    quiz: SignalRQuiz
    lecture: SignalRLecture
}

export interface SignalRUserMap {
    [key: string]: SignalRUser
}

export interface SignalRUser {
    id: string
    name: string
    role: UserRole
    groupId: number
    iclassId: number
    point: SessionPoint
    quizQuestion: AssessmentAnswer[]
    isSubmitLecture: boolean
    lectureQuestion: AssessmentAnswer[]
    connectionId: string
    connected: boolean
}

export interface SignalRGroups {
    [key: string]: {
        id: number
        name: string
        point: SessionPoint
    }
}

export interface SignalRQuiz {
    currentQuestion: QuizCurrentQuestion,
    isStart: boolean
    questionTime: number
    showCorrectAnswer: number
    showRanking: number
    state: QuizState
}

export interface SignalRLecture {
    showCorrectAnswer: number
}